import { createContext } from 'react';
import { TagContextData } from './interfaces/tag-context-props.interface';

const TagContext = createContext<TagContextData>({} as TagContextData);

export default TagContext;
